import { SupplierBase } from "../json-schemas/base/supplier"
import { I18nService } from "./i18n.service"
import i18nScopedData from './currency.service.yml'

const i18nScoped = new I18nService(i18nScopedData)
export type Currency = SupplierBase['currency'];

export const currencySymbols: { [currency in Currency]: { position: 'after' | 'before', symbol: string, info: string } } = {
  EUR: { position: 'after', symbol: '€', info: '' },
  USD: { position: 'before', symbol: '$', info: 'USD' },
  CAD: { position: 'before', symbol: '$', info: 'CAD' },
  XOF: { position: 'after', symbol: 'XOF', info: '' },
  CHF: { position: 'after', symbol: 'CHF', info: '' }
}

export function currencyFormat (currency: Currency, value: string) {
  const formattedNumber = Intl && Intl.NumberFormat ? new Intl.NumberFormat(window.locale).format(parseFloat(value)) : value
  return currencyWrap(currency, formattedNumber)
}

export function currencyWrap (format: Currency, value: string) {
  const position = currencySymbols[format].position || 'after'
  const symbol = currencySymbols[format].symbol || format

  return (position === 'before' ? symbol : '')
    + value
    + (position === 'after' ? symbol : '')
    + (currencySymbols[format].info ? ' ' + currencySymbols[format].info : '')
}

export function currencyWrapTaxNotice (expression: string | number, withTax: boolean): string
export function currencyWrapTaxNotice (expression: JSX.Element, withTax: boolean): JSX.Element
export function currencyWrapTaxNotice (expression: string | number | JSX.Element, withTax: boolean): string | JSX.Element
export function currencyWrapTaxNotice (expression: string | number | JSX.Element, withTax: boolean): string | JSX.Element {
  const method = typeof expression === 'object' ? 'tFragment' : 't'
  return i18nScoped[method](`tax_notice.${withTax ? 'with_tax_short' : 'without_tax_short'}`, { expression })
}
